import FormItem from "@components/formItem";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import { PaymentContentWrapper } from "@pages/profile-v2/pages/withdraw/baseItems";
import React from "react";
import MaskInput from "react-maskinput";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput, StakeFieldWrapper } from "../baseItems";
import Base from "./base";
export default class BetterBro extends Base {
	onSelectTaxIdType(e) {
		this.setState(
			{
				tax_id_type: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	makeExternalPayment(newStep) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				currency: this.state.selectedCurrency,
				method: this.props.externalFunc.method,
				receiver_clabe: this.state.receiver_clabe,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				claimsBonus: true,
				bonusId: bonusId,
				currency: this.state.selectedCurrency,
				method: this.props.externalFunc.method,
				receiver_clabe: this.state.receiver_clabe,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	getStep1(translate) {
		const { selectedDeposit } = this.props;
		const { tax_id_type, tax_id } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<PaymentContentWrapper>
					<div>{this.getCurrencyField(translate)}</div>
					<div>
						<StakeFieldWrapper>
							<div className="stake-field">{this.getStakeField()}</div>
							<div className="min-max-field">{this.renderMinMax()}</div>
						</StakeFieldWrapper>
					</div>
				</PaymentContentWrapper>
				{selectedDeposit.id === "BetterBroOXXO" && (
					<>
						<FormItem onRegister={() => this.registerField({ name: "tax_id_type" })}>
							<Box>
								<BoxTitle>{translate("SELECT_DOC_TYPE")}</BoxTitle>
								<PaymentSelect
									value={tax_id_type}
									options={[
										{ value: 0, label: translate("PLEASE_SELECT") },
										{ value: "RFC", label: "RFC" },
										{ value: "CURP", label: "CURP" },
									]}
									handleSelect={this.onSelectTaxIdType.bind(this)}
								/>
							</Box>
						</FormItem>
						{tax_id_type && (
							<FormItem onRegister={() => this.registerField({ name: "tax_id" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<MaskedInput>
										<MaskInput
											ref={this.ssnRef}
											alwaysShowMask={window.IS_MARS ? true : false}
											value={tax_id}
											mask={
												tax_id_type === "RFC"
													? "*************"
													: "*******************"
											}
											maskChar={"_"}
											size={tax_id_type === "RFC" ? 13 : 18}
											onChange={(e) => this.onEnterValue("tax_id", e)}
										/>
									</MaskedInput>
								</Box>
							</FormItem>
						)}
					</>
				)}
			</Content>
		);
	}
}
